import React, { useEffect, useMemo, useState } from 'react'
import _ from 'lodash'
import { useDropzone } from 'react-dropzone'
import { Trans } from 'react-i18next'
import { Icon } from 'semantic-ui-react'
import { BLUE } from '../../colors'
import styles from '../styles'
import XCancelButton from '../Buttons/CancelButton'
import { theme } from '../../theme'

const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.dark.foreground,
  borderRadius: 10,
  transition: 'border .24s ease-in-out',
  height: '3.125rem'
}

const activeStyle = {
  borderColor: BLUE
}

const thumbsContainer = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  marginTop: '1rem'
}

export const UploadImage = (props) => {
  const { handleUpload, maxUploads, removeImage, allowFiles, text, allowVideo, allowLab } = props
  const [files, setFiles] = useState([])

  const fileTypes = useMemo(() => {
    let allowedTypes = 'image/*'
    if (allowFiles) allowedTypes = 'text/*, .doc, .docx, .pdf, application/vnd.ms-excel'
    if (allowVideo) allowedTypes += ', video/*'
    if (allowLab) allowedTypes = '.lab'
    return allowedTypes
  }, [allowFiles, allowVideo])

  useEffect(() => {
    return files.forEach(file => URL.revokeObjectURL(file.preview))
  }, [])

  // accept is very picky. It's probably not a good idea to allow any file type to be uploaded so I've tried to think of the most common ones.
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: fileTypes,
    onDrop: acceptedFiles => {
      const _files = [...files, ...acceptedFiles]
      setFiles(_files)
      if (maxUploads === 1) {
        setFiles([Object.assign(_files[0], {
          preview: URL.createObjectURL(_files[0])
        })])
        handleUpload(_files[0])
      } else {
        setFiles(_files.map(file => Object.assign(file, {
          preview: URL.createObjectURL(file)
        })))
        handleUpload(_files)
      }
    }
  })

  const style = useMemo(() => ({
    ...baseStyle,
    ...(isDragActive ? activeStyle : {})
  }), [isDragActive])

  const removeFile = file => {
    const _files = _.filter(files, f => f.name !== file.name)
    setFiles(_files)
    if (removeImage) {
      removeImage(file)
    }
  }

  /** Preview Image Utility Methods */

  const thumbs = files.map(file => (
    <div style={styles.thumb} key={file.name}>
      <div style={styles.thumbInner}>
        {file.type.includes('image')
          ? <img src={file.preview} style={styles.thumbImg} />
          : file.type.includes('video')
            ? <video src={file.preview} style={styles.thumbImg} />
            : <div>{file.name}</div>}
        <XCancelButton onClick={() => removeFile(file)} />
      </div>
    </div>
  ))

  return (
    <section className='container'>
      <div {...getRootProps({ style })}>
        <input {...getInputProps()} />
        <Icon name='cloud upload' inverted size='large' style={{ marginRight: '1rem', color: BLUE }} />
        {text
          ? <p>{text}</p>
          : <p><Trans i18nkey='upload.image'>Drag image here or click to upload</Trans></p>}
      </div>
      <aside style={thumbsContainer}>
        {thumbs}
      </aside>
    </section>
  )
}

export default UploadImage
